
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-filters-ghibli",
      function () {
        return require("private-next-pages/ai-filters-ghibli/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-filters-ghibli"])
      });
    }
  